export const INSIGHT_CATEGORIES = [
  "Audit and Assurance",
  "Technology Risk",
  "Business Transformation",
  "Financial Advisory",
  "Tax and Regulatory Developments",
  "Legal and Commercial Insights",
  "Independent Professional Services",
];

// SAMPLE DRAFT CONTENT — for layout demonstration only. Replace before publication.
export const ARTICLES = [
  {
    slug: "scoping-an-internal-audit-co-source-engagement",
    title: "Scoping an internal audit co-source engagement",
    category: "Audit and Assurance",
    service: "auditing",
    readTime: "5 min read",
    image: "/images/auditing.jpg",
    excerpt: "A practical framework for defining the scope, reporting lines and deliverables of a co-sourced internal audit assignment.",
    body: [
      { h: "Start with the audit plan, not the resource gap", p: "Before seeking external support, it helps to confirm which reviews in the annual plan are at risk and why — capacity, specialist skills or independence. The answer shapes the profile of practitioner you need." },
      { h: "Define reporting lines early", p: "Co-sourced practitioners typically work under the direction of the head of internal audit. Agreeing how fieldwork, findings and draft reports will flow avoids confusion once work begins." },
      { h: "Agree deliverables and quality expectations", p: "Set out the expected outputs — testing documentation, findings, management actions — and the methodology or templates the practitioner should follow." },
      { h: "Consider independence and access", p: "Confirm that the practitioner has no relationships that could impair objectivity, and plan system and data access in line with your information security policies." },
    ],
  },
  {
    slug: "questions-to-ask-before-an-it-audit",
    title: "Questions to ask before commissioning an IT audit",
    category: "Technology Risk",
    service: "auditing",
    readTime: "4 min read",
    image: "/images/skyline.jpg",
    excerpt: "Clarifying objectives, systems in scope and the intended audience of the report before an IT audit begins.",
    body: [
      { h: "What decision will the audit inform?", p: "An IT audit commissioned to support an external audit differs from one intended to give the board comfort over a systems migration. Clarity on purpose determines scope and depth." },
      { h: "Which systems and processes are in scope?", p: "List the applications, infrastructure layers and processes — access management, change management, operations — that the review should cover." },
      { h: "Who will rely on the findings?", p: "Understanding the audience helps the practitioner calibrate reporting, evidence standards and the level of technical detail." },
    ],
  },
  {
    slug: "independent-specialists-in-transformation-programmes",
    title: "Where independent specialists add value in transformation programmes",
    category: "Business Transformation",
    service: "consulting",
    readTime: "6 min read",
    image: "/images/consulting.jpg",
    excerpt: "Observations on the roles in a transformation programme that often benefit from experienced, independent practitioners.",
    body: [
      { h: "Workstream leadership", p: "Programmes frequently need experienced leaders for specific workstreams — data migration, process design or change management — for a defined period." },
      { h: "Independent assurance", p: "An independent reviewer can provide the steering committee with an objective view of progress, risks and readiness at key decision points." },
      { h: "Knowledge transfer", p: "Engagements can be structured so that internal teams build capability alongside the specialist, reducing reliance once the programme concludes." },
    ],
  },
  {
    slug: "preparing-for-financial-due-diligence",
    title: "Preparing for financial due diligence: a checklist approach",
    category: "Financial Advisory",
    service: "advisory",
    readTime: "5 min read",
    image: "/images/advisory.jpg",
    excerpt: "An outline of the information and preparation that typically supports an efficient financial due diligence process.",
    body: [
      { h: "Organise core financial information", p: "Historical financial statements, management accounts and key reconciliations form the foundation of most financial reviews." },
      { h: "Anticipate areas of focus", p: "Quality of earnings, working capital, net debt items and one-off adjustments are common areas where advisers will seek supporting analysis." },
      { h: "Plan confidentiality and access", p: "Set up a structured data room and agree confidentiality arrangements before sharing sensitive information with any adviser." },
    ],
  },
  {
    slug: "coordinating-cross-border-tax-advice",
    title: "Coordinating tax advice across multiple jurisdictions",
    category: "Tax and Regulatory Developments",
    service: "tax",
    readTime: "4 min read",
    image: "/images/tax.jpg",
    excerpt: "Considerations for organising tax input from several local advisers into a coherent view for decision-makers.",
    body: [
      { h: "Map the questions by jurisdiction", p: "Break the overall question into the components that each jurisdiction's adviser needs to address, along with the facts they will rely on." },
      { h: "Use a consistent fact pattern", p: "Providing every adviser with the same, agreed description of the arrangement reduces the risk of inconsistent assumptions." },
      { h: "Assign a coordinating lead", p: "A coordinating professional can consolidate input, highlight interactions between jurisdictions and identify open points for decision-makers." },
    ],
  },
  {
    slug: "briefing-external-counsel-on-commercial-contracts",
    title: "Briefing external counsel on a commercial contract review",
    category: "Legal and Commercial Insights",
    service: "law",
    readTime: "4 min read",
    image: "/images/law.jpg",
    excerpt: "How a clear, structured brief can help a legal practitioner focus on the issues that matter most to the business.",
    body: [
      { h: "Explain the commercial context", p: "Describe the relationship, the value and duration of the contract and the business objectives, so that legal review is anchored in commercial priorities." },
      { h: "Identify priority issues", p: "Highlight the terms of greatest concern — liability, termination, intellectual property, data — and any internal policy positions." },
      { h: "Confirm governing law and admission", p: "Ensure the practitioner is appropriately admitted for the governing law of the contract or has arranged suitable local input." },
    ],
  },
  {
    slug: "working-with-independent-professionals",
    title: "Working effectively with independent professionals",
    category: "Independent Professional Services",
    service: null,
    readTime: "5 min read",
    image: "/images/collaboration.jpg",
    excerpt: "Practical habits that help organisations and independent practitioners establish productive, well-governed engagements.",
    body: [
      { h: "Agree scope in writing", p: "A clear written scope, including deliverables, timelines and assumptions, is the most effective safeguard against misunderstanding." },
      { h: "Set up governance proportionately", p: "Regular check-ins, a named sponsor and an agreed escalation route help keep focused engagements on track without unnecessary bureaucracy." },
      { h: "Close out deliberately", p: "Confirm that deliverables are accepted, knowledge has been transferred and feedback is captured at the end of each engagement." },
    ],
  },
];

export const getArticle = (slug) => ARTICLES.find((a) => a.slug === slug);
